!function(){
    $('.content-rentIn').on('click', '.icon', function(){
        $((".icon_big[data-index=\"" + (this.dataset['index']) + "\"]")).attr('src', this.dataset['src']);
    });

    function initSlider(container) {
        var currentRentCard = container.querySelector('.card.current');
        var fadeOutTimer;
        var nextPromise = Promise.resolve(true);
        var pendignSlide = false;

        function getNextCard(currentCard, forwardDirection) {
            if ( forwardDirection === void 0 ) forwardDirection = true;

            var nextCard = currentCard[forwardDirection ? 'nextElementSibling' : 'previousElementSibling'];
            if (!nextCard) {
                nextCard = currentCard.parentNode[forwardDirection ? 'firstElementChild' : 'lastElementChild'];
            }
            return nextCard;
        };

        function slideToNextCard(fetchUrl, forwardDirection) {
            if ( forwardDirection === void 0 ) forwardDirection = true;

            if (pendignSlide) return;
            pendignSlide = true;
            nextPromise.then(function (){
                pendignSlide = false;
                if (currentRentCard) {
                    currentRentCard.classList.remove('current-fade');
                    currentRentCard.classList.add('current-fade');
                    var nextCard = getNextCard(currentRentCard, forwardDirection);
                    var pendingCard = getNextCard(nextCard, forwardDirection);
                    var loadIndex = -1;
                    var pendingIndex = Number(pendingCard.dataset['index']);
                    var curIndex = Number(nextCard.dataset['index']);
                    var locationId = Number(nextCard.dataset['location']);
                    $(container).find(".js-slider__cur-slide-id").text(curIndex + 1);
                    if (forwardDirection) {
                        var count = nextCard.parentNode.dataset['total'];
                        if ((pendingIndex < count) &&
                            (pendingIndex > curIndex) &&
                            (pendingIndex - curIndex > 1)) {
                            loadIndex = curIndex + 1;
                        }
                    } else {
                        if ((pendingIndex < curIndex) &&
                            (curIndex - pendingIndex > 1)) {
                            loadIndex = curIndex - 1;
                        }
                    }
                    if (loadIndex > 0) {
                        nextPromise = new Promise(function (resolve, reject){
                            fetch(("" + fetchUrl + locationId + "/" + loadIndex + "/")).then(function (response){
                                if (response.status != 200) {
                                    throw new Error();
                                }
                                return response.text();
                            }).then(function (html) {
                                nextCard.insertAdjacentHTML('afterend', html);
                                resolve();
                            }).catch(function (){
                                reject();
                            });
                        });
                    } else {
                        nextPromise = Promise.resolve(true);
                    }

                    setTimeout(function (){
                        currentRentCard.classList.remove('current');
                        nextCard.classList.add('current-fade');
                        nextCard.classList.add('current');
                        currentRentCard = nextCard;
                        fadeOutTimer = setTimeout(function (){
                            fadeOutTimer = nextCard.classList.remove('current-fade');
                        }, 200);
												$(container).find(".card-thumb").removeClass('card-thumb--current');
												$(container).find(".card-thumb[data-index='" + curIndex + "']").addClass('card-thumb--current');
                    }, 200);
                }
            }).catch(function (){
                nextPromise = Promise.resolve(true);
                pendignSlide = false;
            });
        }
        $(container).on('click', '.arr', function(){
						slideToNextCard(this.parentNode.parentNode.dataset['url'], Number(this.dataset['direction']));
				});
        function goToSlide(fetchUrl, forwardDirection, slideId) {
            if ( forwardDirection === void 0 ) forwardDirection = true;

            if (pendignSlide) return;
            pendignSlide = true;
            nextPromise.then(function (){
                pendignSlide = false;
                if (currentRentCard) {
									var card = $(container).find(".card[data-index='" + slideId + "']"); 
									$(container).find(".card").removeClass('current');
									$(container).find(".card").addClass('current-fade');
									card.addClass('current');
									setTimeout(function() {
										card.removeClass('current-fade');
									}, 200);

									$(container).find(".card-thumb").removeClass('card-thumb--current');
									$(container).find(".card-thumb[data-index='" + slideId + "']").addClass('card-thumb--current');
                }
            }).catch(function (){
                nextPromise = Promise.resolve(true);
                pendignSlide = false;
            });
        }
        $(container).on('click', '.js-slider__go-to', function(){
        //$('.js-slider__go-to').on('click', function(){
						goToSlide(
							this.parentNode.dataset['url'],
							Number(this.dataset['direction']),
							Number(this.dataset['index'])
						)
				});
    }
    $('.slider').each(function(e){initSlider(this);});

    $('form').on('submit', function(e){
        e.preventDefault();

        var xhr = new XMLHttpRequest();
        var fd = new FormData(this);
        var form = this;

        //$(form).find('button').attr('disabled', 'disabled');
        var btn = new OperationButton($(form).find('button')[0]);
        btn.start();
        xhr.open('POST', this.getAttribute('action'), true);
        xhr.onreadystatechange = function (e){
            if (xhr.readyState == 4) {
                btn.stop();
                if (xhr.status == 200) {
                    form.reset();
                    popup.classList.remove('hidden-transparent');
                    popup.classList.remove('hidden');
                    setTimeout(function (e){
                        popup.classList.add('hidden-transparent');
                    }, 5000);
                    setTimeout(function (){
                        popup.classList.add('hidden');
                    }, 5500);
                } else if (xhr.status == 403) {
                    var popup$1 = document.getElementById('popup-captcha-fail');
                    popup$1.classList.remove('hidden-transparent');
                    popup$1.classList.remove('hidden');
                    setTimeout(function (e){
                        popup$1.classList.add('hidden-transparent');
                    }, 5000);
                    setTimeout(function (){
                        popup$1.classList.add('hidden');
                    }, 5500);
                } else if (xhr.status == 415) {
                    var popup$1 = document.getElementById('popup-bad-media');
                    popup$1.classList.remove('hidden-transparent');
                    popup$1.classList.remove('hidden');
                    setTimeout(function (e){
                        popup$1.classList.add('hidden-transparent');
                    }, 5000);
                    setTimeout(function (){
                        popup$1.classList.add('hidden');
                    }, 5500);
                } else {
                    var popup$1 = document.getElementById('popup-fail');
                    popup$1.classList.remove('hidden-transparent');
                    popup$1.classList.remove('hidden');
                    setTimeout(function (e){
                        popup$1.classList.add('hidden-transparent');
                    }, 5000);
                    setTimeout(function (){
                        popup$1.classList.add('hidden');
                    }, 5500);
                }

            }
        };
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.send(fd);
        return false;
    });

    function toggleSliderByLocation(sliderType, locationId) {
      var sliders = document.getElementsByClassName('slider--'+sliderType);
      $(sliders).removeClass('slider--visible');
      var slider = document.querySelectorAll(".slider--"+sliderType+"[data-location='"+locationId+"']");
      $(slider).addClass('slider--visible');
      console.log(sliderType, locationId);
    };

    $('.js-slider__location-select--rent').on('change', function() {
      var locationId = this.value;
      toggleSliderByLocation('rent', locationId);
    });
    $('.js-slider__location-select--sale').on('change', function() {
      var locationId = this.value;
      toggleSliderByLocation('sale', locationId);
    });

}();

//# sourceMappingURL=rent.min.js.map
